import React from "react";
import { NavLink } from "react-router-dom";
import { ClinicBoxItem } from "../../components";

export const PatientsVisits = (props) => {
  const ambulances = JSON.parse(localStorage.getItem("user")).ambulances;
  const myAmbulanceList = ambulances.map((ambulance) => (
    <div className="item">
      <ClinicBoxItem
        key={ambulance.id}
        abbreviation={ambulance.abbreviation}
        description={ambulance.description}
        careType="ambulation"
      />
    </div>
  ));
  return (
    <div>
      <h1>Ambulantní pacienti - rozcestník</h1>
      <div className="signpost-wrap">
        <div className="signpost">{myAmbulanceList}</div>
        <div className="signpost single">
          <div className="item">
            <NavLink to="all-clinics/ambulation">
              <span className="icon">
                <i className="fas fa-clinic-medical"></i>
                <u>150</u>
              </span>
              <span className="name">Všechny kliniky</span>
            </NavLink>
          </div>
        </div>
      </div>
      <div className="signpost-wrap search">
        <div className="signpost ">
          <div className="item">
            <NavLink to="/patient-lookup">
              <span className="icon">
                <i className="fas fa-search"></i>
              </span>
              <span className="name">
                Hledání konkrétního
                <br /> pacienta
              </span>
            </NavLink>
          </div>
          <div className="item">
            <NavLink to="/requisitions/ambulation">
              <span className="icon">
                <i className="fa fa-clipboard" aria-hidden="true"></i>
              </span>
              <span className="name">
                Nezpracované
                <br /> žádanky
              </span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  );
};
